module.exports = __webpack_public_path__ + "img/BAU Seniors_Infographics_64.6a959a69.png";